import { render, staticRenderFns } from "./StatTaskedStatisticFile.vue?vue&type=template&id=c5418d54&scoped=true&"
import script from "./StatTaskedStatisticFile.vue?vue&type=script&lang=ts&"
export * from "./StatTaskedStatisticFile.vue?vue&type=script&lang=ts&"
import style0 from "./StatTaskedStatisticFile.vue?vue&type=style&index=0&id=c5418d54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5418d54",
  null
  
)

export default component.exports